/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { APIEndpoint } from "../../../utils/axios";
import { DataGrid,LoaderPop,Modal,ApplicableCurrenciesTable } from "../../../common";
import searchIcon from '../../../assets/icons/search.svg';
import moment from 'moment';
import {formatDateByTimezone} from '../../../utils/commonFunctions';
import editIcon2 from "../../../assets/edit2.svg"
import { Input } from "../../../common/Input";
import { useTranslation } from 'react-i18next';
import usePermissions from '../../../utils/userPermissions';
import CustomSelect from '../../../common/CustomSelect';

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters:[],
    limit: 50,
    page: 1,
    searchParam: ''
  };
  
const Columns = [
  { field: 'code', headerName: 'Drawer Code', suppressSizeToFit:true,resizable:true,flex:1,minWidth:100 },
  { field: 'name', headerName: 'Drawer Name', suppressSizeToFit:true,valueGetter: (params) => {
      if (params.data && params.data?.name && params.data.location) {
         return `${params.data?.name} (${params.data.location?.locationCode})` ;
      }
      return null;
    },resizable:true,flex:1,minWidth:190,width:230},
  { field: 'location.locationName', headerName: 'Location',valueGetter: (params) => {
      if (params.data && params.data.location) {
         return params.data.location?.locationName ;
      }
      return null;
    }, suppressSizeToFit:true,resizable:true,flex:1,minWidth:150,width:160 },
  { field: 'effectiveDateFrom', headerName: 'Effective From',flex:1, valueGetter: (params) => {
          return params?.data && params?.data?.effectiveDateFrom ? moment.parseZone(formatDateByTimezone(params?.data?.effectiveDateFrom)).format("DD-MM-YYYY"):null
        }, suppressSizeToFit:true,resizable:true,minWidth:100},
  { field: 'effectiveDateTo', headerName: 'Effective Until',flex:1,valueGetter: (params) => {
          return params?.data && params?.data?.effectiveDateTo ? moment.parseZone(formatDateByTimezone(params?.data?.effectiveDateTo)).format("DD-MM-YYYY"):null
        },  suppressSizeToFit:true,resizable:true,minWidth:100 },
  { field: 'isActive', headerName: 'Status', valueGetter: (params) => {
    if (params && params.data) {
     return params?.data?.isActive === true ? "Active" : params?.data?.isActive === false ? "Inactive" : null;
    } else {
      return null;
    }
        },suppressSizeToFit:true,flex:1,resizable:true ,minWidth:100},

]

const CreateFormFields = [
  { label: 'Drawer Name', attribute: 'drawName', type: 'text', required: true },
  { label: 'Location', attribute: 'airportId', type: 'selectSearch2',options:[], required: true },
  { label: 'Effective From', attribute: 'effectiveFrom', type: 'date', required: true },
  { label: 'Effective Until', attribute: 'effectiveTo', type: 'date', required: true },
];

const EditFormFields = [
  { label: 'Drawer Name', attribute: 'drawName', type: 'text', disabled: true },
  { label: 'Location', attribute: 'airportId', type: 'selectSearch2', required: true },
  { label: 'Effective From', attribute: 'effectiveFrom', type: 'date', required: true },
  { label: 'Effective Until', attribute: 'effectiveTo', type: 'date', required: true },
  { label: 'Active', attribute: 'active', type: 'checkbox' }
];

export const CashDrawersJzrPage = (props) => {
  const { t,ready } = useTranslation();
  const [state, setState] = useState({
  cashDrawerList: null,
  data: null,
  showCreateDialog: false,
  showEditDialog: false,
  selectedDrawer: null,
  modalFormStatusObj: { text: '' }
});
const [cashDrawer, setCashDrawer] = useState('');
const [location, setLocation] = useState('');
const [searchKey, setSearchKey] = useState('');
const [resetDataSource, setResetDataSource] = useState(false);
const [currencyMaster, setCurrencyMaster] = useState([]);
const [drawCurrencies, setDrawCurrencies] = useState([]);
const [editFormValues, setEditFormValues] = useState({});
const [isDropDownOpen,setIsDropdownOpen]=useState(false);
const [balanceDetailsDrawer,setBalanceDetailsDrawer]=useState(false);
const [ModalContHeight,setModalContHeight]=useState({marginBottom:'auto'})
const airportsFetchedRef = React.useRef(false);
const drawersFetchedRef = React.useRef(false);
const activeEditIdRef = React.useRef(null);
const isMountedRef = React.useRef(true);
const timeoutRef = React.useRef(null);
useEffect(() => {
  return () => {
    isMountedRef.current = false;
  };
}, []);

  const { hasPermission: createCashDrawers } = usePermissions('create', "orn:Account:CreateCashDrawer");
  const { hasPermission: editCashDrawers } = usePermissions('edit', "orn:Account:CreateCashDrawer");

  React.useEffect(() => {
    if(isDropDownOpen){
      setModalContHeight({marginBottom:'10rem'})
    }else{
      setModalContHeight({marginBottom:'auto'})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]);

useEffect(() => {
  if (!ready) return;

  fetchCashDrawersList();
  fetchAirports();
}, [ready]);

useEffect(() => {
  setResetDataSource(prev => !prev);
}, [cashDrawer, location]);

useEffect(() => {
  return () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };
}, [])


const fetchCashDrawersListMain = async (cashDrawerId) => {
  if (!cashDrawerId) return false;
  try {
    const res = await APIEndpoint.get(
      `cashRegister/cashDrawers/${cashDrawerId}`
    );

    const drawerDetails = res?.cashDrawer;
if (!res || !res.cashDrawer) {
  setBalanceDetailsDrawer(false);
  return;
}

    const hasBalance =
      Array.isArray(drawerDetails?.currentBalance) &&
      drawerDetails.currentBalance.some(
        b => Number(b?.amount) > 0
      );
    return hasBalance;

  } catch (error) {
    console.error("Error fetching cash drawer details:", error);
    return false;
  }
};



const editFields = React.useMemo(() => {
  if (!state.showEditDialog || !state.selectedDrawer) return [];

  return EditFormFields.map(f => ({
    ...f,
    options: f.attribute === 'airportId' ? state.airports : undefined,
    initialValue: editFormValues[f.attribute],
    ...(f.attribute === 'active' && balanceDetailsDrawer
      ? { note: '* Cash Balance exists for this drawer' }
      : {})
  }));
}, [
  state.showEditDialog,
  state.selectedDrawer,
  editFormValues,
  state.airports,
  balanceDetailsDrawer
])

const sectorTitle=()=>{
  const {code}=state.selectedDrawer;

  if(state && state.showEditDialog && code?.length>0){          
return(<div className='flexRow justifyContentCenter'>
  <div className='flexRow'> 
    <div className='flexRow'>Edit Cash Drawer - <div className='instance-member-name'>{code}</div></div>
  </div>
</div>)
  }
  else{
    return(<></>)
  }

}

  const fetchCashDrawersList = async () => {
    if(state.cashDrawerList?.length)return;
      if (drawersFetchedRef.current) return;
  drawersFetchedRef.current = true;
    try {
       const res = await APIEndpoint.get('cashRegister/cashDrawers');
if (!isMountedRef.current) return;
    const list = (res.result || []).map((_) => ({ value: _.id, label: _.value }));
    setState((_) => ({ ..._, cashDrawerList: list }))
    } catch (error) {

    }
  }



const fetchCashDrawers = useCallback(
  async (page = 1, perPage = 50) => {
    const payload = {
      ...filterData,
      page,
      limit: perPage,
      searchParam: searchKey,
      filters: [
        {
          ...(location && { locationId: location }),
          ...(cashDrawer && { cashDrawerId: cashDrawer })
        }
      ]
    };

    try {
      const res = await APIEndpoint.post(
        'cashRegister/cashDrawers/list',
        payload
      );
      return res;
    } catch (error) {
      console.error('Failed to fetch list:', error);
    }
  },
  [searchKey, location, cashDrawer]
);



  const fetchAirports = async () => {
      if (airportsFetchedRef.current) return;
  airportsFetchedRef.current = true;
    try {

          const [res, resActCurrency] = await Promise.all([
            APIEndpoint.get("airports"),
            APIEndpoint.get("currencies"),
          ]);
if(res && isMountedRef.current){
  const list = (res.items || []).map((_) => ({ value: _.id, label: `${_.locationName}` }));
  setState((_) => ({ ..._, airports: list }))
}
if (resActCurrency && resActCurrency?.items?.length && isMountedRef.current) {
  const activeCurrencyCodes = resActCurrency.items
    .filter(c => c.isActive)
       .map((c, index) => ({
      key: index + 1,
      label: c.name,  
      value: c.code  
    }));

  setCurrencyMaster(activeCurrencyCodes);
}

    } catch (error) {

    }

  }
  const onSearch = (e) => {
    setSearchKey(e.target.value);
    setResetDataSource(prev => !prev);
  };

  const onAction = async (e,action, rowData) =>{
if (action?.value === 'EditItem' && rowData) {
  const editValues = mapDrawerToEditFormValues(rowData);
    activeEditIdRef.current = rowData.id;
setDrawCurrencies(
  Array.isArray(rowData.enabledCurrencies)
    ? rowData.enabledCurrencies.map(c => ({
        currencyCode: c.currencyCode,
        currencyName: c.currencyName,
        active: true
      }))
    : []
);
setEditFormValues(editValues);
  const hasBalance = await fetchCashDrawersListMain(rowData?.id);
  if (!isMountedRef.current) return;
    if (activeEditIdRef.current !== rowData.id) return;
  setBalanceDetailsDrawer(hasBalance);
setState(prev => ({
  ...prev,
  selectedDrawer: rowData,
  showEditDialog: true
}));
}

  };
const handleAddCurrency = (currency) => {
  if (!currency) return;

  const exists = drawCurrencies?.some(
    c => c.currencyCode === currency.value
  );

  if (exists) {
    setState(prev => ({
      ...prev,
      modalFormStatusObj: { error: 'Currency already added to the draw' }
    }));
    return;
  }

  setDrawCurrencies(prev => [
    ...prev,
    {
      currencyCode: currency.value, 
      currencyName: currency.label, 
      active: true
    }
  ]);
};




const handleOnchangeCashDrawers = (e) => {
  if (!e?.target) {
    setState(prev => ({
      ...prev,
      modalFormStatusObj: { text: "" },
      formValues: {
        ...prev.formValues,
        airportId: e?.value ?? ""
      }
    }));
    return;
  }

  const { name, value } = e.target;

  setState(prev => {
    const updated = {
      ...prev.formValues,
      [name]: value
    };

    if (name === 'effectiveFrom') {
      updated.effectiveTo = '';
    }

    return {
      ...prev,
      modalFormStatusObj: { text: "" },
      formValues: updated
    };
  });
};


const enableButtons = (submitBtnObj, cancelButtonObj) => {
  submitBtnObj?.removeAttribute('disabled');
  if(cancelButtonObj){
  cancelButtonObj?.removeAttribute('disabled');
  }
};
const handleDrawerUpdate = async () => {
 const submitBtnObj = document.getElementsByClassName('done-button')[0];
  submitBtnObj?.setAttribute('disabled', 'true');
  if (state.showCreateDialog) {

    const requiredFields = CreateFormFields.filter(f => f.required).map(f => f.attribute);

    const isValid =
      state.formValues &&
      requiredFields.every(key => state.formValues?.[key]);

    if (!isValid) {
      setState(prev => ({
        ...prev,
        modalFormStatusObj: { error: "Please fill all the required fields" }
      }));
      enableButtons(submitBtnObj,null);
      return;
    }

    const {
      airportId,
      drawName,
      effectiveFrom,
      effectiveTo
    } = state.formValues;

    const body = {
      locationId: airportId,
      name: drawName,
      enabledCurrencyCodes: drawCurrencies
        ?.filter(item => item.active)
        ?.map(item => item.currencyCode),
      effectiveDateFrom: moment
        .parseZone(formatDateByTimezone(effectiveFrom))
        .format("YYYY-MM-DD"),
      effectiveDateTo: moment
        .parseZone(formatDateByTimezone(effectiveTo))
        .format("YYYY-MM-DD")
    };

    try {
      const res = await APIEndpoint.post(
        'cashRegister/cashDrawers',
        body
      );

      if (res?.message) {
        if (!isMountedRef.current) return;
        setState(prev => ({
          ...prev,
          modalFormStatusObj: { text: res.message }
        }));
        fetchCashDrawersList();
      }

     timeoutRef.current = setTimeout(() => {
  if (!isMountedRef.current) return;

  setDrawCurrencies([]);
  setState(prev => ({
    ...prev,
    showCreateDialog: false,
    formValues: {},
    modalFormStatusObj: { text: '' }
  }));
  enableButtons(submitBtnObj, null);
}, 2000);


    } catch (error) {
      const errorMessage =
        error?.message
          ? JSON.parse(error.message)?.data?.message
          : 'Failed to create new drawer';
if (!isMountedRef.current) return;
      setState(prev => ({
        ...prev,
        modalFormStatusObj: { error: errorMessage }
      }));
         enableButtons(submitBtnObj,null);
    }
    setResetDataSource(prev => !prev);
    return;
  }

  const {
    drawName,
    effectiveFrom,
    effectiveTo,
    active
  } = editFormValues;
if(!effectiveFrom || !effectiveTo){
 setState(prev => ({ ...prev,modalFormStatusObj:{error:"Please fill all the required fields"}}));
  enableButtons(submitBtnObj,null);
 return;
}
  const body = {
    name: drawName,
    // status: active ? "ACTIVE" : "INACTIVE",
    enabledCurrencyCodes: drawCurrencies
        ?.filter(item => item.active)
        ?.map(item => item.currencyCode),
    isActive: active,
    effectiveDateFrom:effectiveFrom ? moment
      .parseZone(formatDateByTimezone(effectiveFrom))
      .format("YYYY-MM-DD"):null,
    effectiveDateTo: effectiveTo ? moment
      .parseZone(formatDateByTimezone(effectiveTo))
      .format("YYYY-MM-DD"):null
  };

  try {
    const res = await APIEndpoint.put(
      `cashRegister/cashDrawers/${state.selectedDrawer.id}`,
      body
    );

    if (res && res?.message) {
      setState(prev => ({
        ...prev,
        modalFormStatusObj: { text: res.message }
      }));
      setBalanceDetailsDrawer(false);
    }

   timeoutRef.current = setTimeout(() => {
  if (!isMountedRef.current) return;

  setDrawCurrencies([]);
  setState(prev => ({
    ...prev,
    showEditDialog: false,
    formValues: {},
    modalFormStatusObj: { text: '' }
  }));
  enableButtons(submitBtnObj, null);
}, 2000);


  } catch (error) {
    const errorMessage =
      error?.message
        ? JSON.parse(error.message)?.data?.message
        : 'Failed to update the Drawer';

    setState(prev => ({
      ...prev,
      modalFormStatusObj: { error: errorMessage }
    }));
    enableButtons(submitBtnObj,null);
  }
    setResetDataSource(prev => !prev);

};


const toggleCurrencyActive = (code) => {
  setDrawCurrencies(prev =>
    prev.map(c =>
      c.currencyCode === code
        ? { ...c, active: !c.active }
        : c
    )
  );
};


const currencyOptions = currencyMaster.map(c => ({
  value: c.value,  
  label: `${c.label} (${c.value})`,  
  isDisabled: drawCurrencies?.some(
    d => d.currencyCode === c.value
  )
}));

const handleDeleteCurrency = (currencyCode) => {
  setDrawCurrencies(prev =>
    prev.filter(c => c.currencyCode !== currencyCode)
  );
};

const mapDrawerToEditFormValues = (drawer) => {
  if (!drawer) return {};

  return {
    drawCode: drawer.code,
    drawName: drawer.name,
    airportId: drawer.location?.id, 
    effectiveFrom: new Date(drawer.effectiveDateFrom),
    effectiveTo: new Date(drawer.effectiveDateTo),
    active: drawer.isActive
  };
};



  return (
    <div className="flexCol width100 ag-theme-alpine-dark cash-reg">
      {
        state.cashDrawerList === null ?
          <LoaderPop />
          :
          <div className='flexCol full-flex'>
            <div className='flexRow alignItemsCenter justifyContentSpaceBetween margBottom6'>
              <div className='flexRow alignItemsCenter'>

                <div className='margLeft6'>
                <CustomSelect
                  options={state.cashDrawerList}
                  placeHolder="Search Drawer"
                 onChange={(e) => {
                const drawerId = e?.value || "";
                setCashDrawer(drawerId);
              }}
                />
                </div>
                  <div className='margLeft6'>
                <CustomSelect
                  options={state.airports}
                  placeHolder="Search Location"
                  menuPortalTarget={document?.body}
                  menuPosition="fixed"
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 })
                  }}
                  onChange={(e) => {
                    setLocation(e?.value|| "");
                  }}
                />
                </div>
                   <div className="flexRow justifyContentCenter alignItemsCenter width100 content-tabs">
                     <div className="margLeft margBot10 margTop8 underline">
                       <span><img className="icon-size" alt={t('filters.searchText')} src={searchIcon} /></span>
                       <span>
                         <input
                           className="search"
                           onChange={onSearch}
                           type="search"
                           placeholder={t('filters.searchText')}
                           value={searchKey}
                         />
                       </span>
                     </div>
                   </div>
              </div>
               <div className='flexRow justifyContentFlexEnd'>
                  {createCashDrawers? <button className='add-item-button'
                  onClick={() => {
                     if (!state?.airports?.length) return;
                    setState((_) => ({ ..._, showCreateDialog: true }))
                  }}>
                  {t('pages.cashRegisterContent.cashDrawer.addCashDrawer')}
                </button>:<></>}

              </div>
      
            </div>

              <DataGrid
                columnResize
                showDefaultFilters={false}
                enableGridSearch={false}
                className='full-flex'
                columns={Columns}
                getRows={fetchCashDrawers}          
                rowSelection="multiple"
                actions={editCashDrawers ? [{ title: 'Actions', detail: [{src: editIcon2,value:"EditItem",title:'Edit'}] }]:[]}
                onAction={onAction}
                resetDataSource={resetDataSource}
              />

          </div>
      }

{state.showCreateDialog && state.airports && (
  <Modal
    title={t('pages.cashRegisterContent.cashDrawer.newDrawerTitle')}
    buttonLabel="Create"
    modalFormStatusObj={state.modalFormStatusObj}
    onSubmit={handleDrawerUpdate}
    customContentHeight={ModalContHeight}
    setIsDropdownOpen={setIsDropdownOpen}
    onChange={handleOnchangeCashDrawers}
    onClose={() =>{
      setDrawCurrencies([]);
      setState(prev => ({
        ...prev,
        showCreateDialog: false,
        formValues:{},
        modalFormStatusObj: { text: '' }
      }))
    }
    }
  >
{CreateFormFields.map(field => {
  const options =
    field.attribute === 'airportId' ? state.airports : field.options;

  const isEffectiveTo = field.attribute === 'effectiveTo';
  const effectiveFrom = state.formValues?.effectiveFrom;

  return (
    <Input
      key={field.attribute}
      {...field}
      name={field.attribute}
      value={state.formValues?.[field.attribute]}
      onChange={handleOnchangeCashDrawers}
      setIsDropdownOpen={setIsDropdownOpen}
      menuPortalTarget={null}
      menuPosition="absolute"
      options={options}
      disabled={isEffectiveTo && !effectiveFrom}
      {...(isEffectiveTo && effectiveFrom && {
        minDate: new Date(effectiveFrom)
      })}
    />
  );
})}



{state?.formValues && state.formValues?.airportId ?
<ApplicableCurrenciesTable
  currencies={drawCurrencies}
  onAddCurrency={handleAddCurrency}
   onDeleteCurrency={handleDeleteCurrency} 
  onToggleActive={toggleCurrencyActive}
  currencyOptions={currencyOptions}
/>:null}

  </Modal>
)}

{state.showEditDialog && (
  <Modal
    TitleComponent={sectorTitle}
    buttonLabel="Save"
    modalFormStatusObj={state.modalFormStatusObj}
    onSubmit={handleDrawerUpdate}
    onClose={() => {
      setEditFormValues({});
      setBalanceDetailsDrawer(false);
      setDrawCurrencies([]);
      setState(prev => ({ ...prev, showEditDialog: false ,selectedDrawer:null}));
    }}
  >
 
{editFields.map(field => {
  const isCheckbox = field.type === 'checkbox';
  const isLocation = field.attribute === 'airportId';
  const isEffectiveTo = field.attribute === 'effectiveTo';
  const isActiveCheckbox = field.attribute === 'active';

  const options = isLocation ? state.airports : field.options;
  const effectiveFrom = editFormValues?.effectiveFrom;

  return (
    <Input
      key={field.attribute}
      {...field}
      name={field.attribute}

      {...(!isCheckbox && {
        value: editFormValues[field.attribute]
      })}

      {...(isCheckbox && {
        checked: !!editFormValues[field.attribute]
      })}
      disabled={field.attribute === 'drawName' || isLocation || (isEffectiveTo && !effectiveFrom) || (isActiveCheckbox && balanceDetailsDrawer)}
      {...(isEffectiveTo && effectiveFrom && {
        minDate:new Date(effectiveFrom)
      })}
      isDisabled={isLocation}
      onChange={(e) => {
        setState(prev => ({ ...prev,modalFormStatusObj:{text:""}}));
        const value = isCheckbox
          ? e.target.checked
          : e?.target
          ? e.target.value
          : e?.value;

        setEditFormValues(prev => {
          const updated = {
            ...prev,
            [field.attribute]: value
          };
          if (field.attribute === 'effectiveFrom') {
            updated.effectiveTo = '';
          }

          return updated;
        });
      }}

      options={options}
    />
  );
})}

<hr/>

    <ApplicableCurrenciesTable
      currencies={drawCurrencies}
      onAddCurrency={handleAddCurrency}
      onDeleteCurrency={handleDeleteCurrency}
      onToggleActive={toggleCurrencyActive}
      currencyOptions={currencyOptions}
    />
  </Modal>
)}





    {
    !ready && <div className='overlay_hide sub'></div>
    }
    </div>
  )
}
